import React from "react";

const UnderConstruction = () => {
  return <h1 style={{ textAlign: "center" }}>Work in Progress...</h1>;
};

export default UnderConstruction;
